import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { FaRegAddressBook } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'
import { CgDanger } from 'react-icons/cg'
import Toast from './../components/toast'
import axios from "axios";
import Storages from "../helper/storages";
import useEndpoints from "../api/useEndpoints";
export default function AddFavoriteAddress(props) {
    var endpoints = useEndpoints();


    var [state, setState] = useState();

    const handleClose = () => {
        props?.onClose();
    }

    const handleSave = (event) => {
        console.log(Storages.getUserToken())
        props?.onClose();
        axios.post(endpoints.favoriteAddress, {
            titleName: state?.titleName,
            destAddress: state?.destAddress,
            nameReciver: state?.nameReciver,
            mobileReciver: state?.phoneNumber
        }, {

            headers: {
                "x-auth-token": Storages.getUserToken(),
            },
        })
            .then((res) => {
                // toast.Success("با موفقیت حذف شد")
                // getFavoriteAddress()
            })
            .catch((e) => {
                console.log(e);
            });

        event.preventDefault();


    }
    const handleEnter = (event) => {
        if (event.key.toLowerCase() == "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };



    const handleOnChange = (e) => {
        try {
            var value = e.target.value;
            var name = e.target.name;
            setState(prevState => ({
                ...prevState,
                [name]: value
            }))
        } catch (err) {
            console.log(err);
        }
    };


    return (<>
        <div>

            <Modal show={props.show} onHide={handleClose} centered size="md">

                <Modal.Body >
                    <div className="justify-content-center align-items-center  position-relative d-flex row px-3  " >
                        <h2 className="p-1 m-0"><FaRegAddressBook size={30} /> افزودن مقصد دلخواه جدید</h2>
                        <form className="row p-0 m-0 col-12   ">
                            <div className="col-12 m-0 p-0 ">
                                <div className=" m-1">
                                    <h5>عنوان</h5>
                                    <input
                                        type="text"
                                        className="form-control inputReq"
                                        placeholder="عنوان را اینجا وارد کنید"
                                        onKeyDown={handleEnter}
                                        onChange={handleOnChange}
                                        name="titleName"

                                    />

                                </div>
                            </div>
                            <div className="col-12 m-0 p-0 ">
                                <div className=" m-1">
                                    <h5>آدرس مقصد</h5>
                                    <input
                                        type="text"
                                        className="form-control inputReq"
                                        placeholder="آدرس گیرنده را اینجا وارد کنید"
                                        onKeyDown={handleEnter}
                                        onChange={handleOnChange}
                                        name="destAddress"

                                    />

                                </div>
                            </div>


                            <div className="col-12 col-sm-6  m-0 p-0 ">
                                <div className=" m-1">
                                    <h5>همراه گیرنده</h5>
                                    <input
                                        type="number"
                                        className="form-control inputReq"
                                        placeholder="شماره گیرنده را اینجا وارد کنید"
                                        onKeyDown={handleEnter}
                                        maxLength="11"
                                        onChange={handleOnChange}
                                        name="phoneNumber"
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6  m-0 p-0 ">
                                <div className=" m-1">
                                    <h5>نام گیرنده</h5>
                                    <input
                                        type="text"
                                        className="form-control inputReq"
                                        placeholder="نام گیرنده را اینجا وارد کنید"
                                        onKeyDown={handleEnter}
                                        onChange={handleOnChange}
                                        name="nameReciver"
                                    />
                                </div>
                            </div>

                            <button
                                className="btn btn-success  iranSansBold col-12 my-2"

                                onClick={handleSave}
                            >
                                <h4 className=" text-center m-0 my-1 p-0">ثبت مقصد دلخواه</h4>
                            </button>
                        </form>
                    </div>

                </Modal.Body>

            </Modal>

        </div>

    </>)
}
